module.exports = __webpack_public_path__ + "img/step04_bg.e247b106.jpg";